/** Acres per hectare — single source of truth on the admin side. */
export const ACRES_PER_HECTARE = 2.47105;
